import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Japanese from './jp'
import English from './en'

Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.getItem('lan'),
  fallbackLocale: 'jp',
  messages: {
    jp: Japanese,
    en: English
  },
  silentTranslationWarn: true
})
